import * as React from "react";
import cable from "~/lib/cable";
import { LimitingJob } from "~/components/job/Job/shared/types";

export function useLimitingJobsSubscription(
  limitingJobs: Array<LimitingJob | null>,
  onJobChange: () => void,
  skipStates: string[] = [],
) {
  React.useEffect(() => {
    // actioncable is an un-typed vendored js library
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const subscriptions: any[] = [];

    limitingJobs.forEach((job) => {
      if (job === null || skipStates.includes(job.state)) {
        return;
      }

      const subscription = cable.subscriptions.create(
        { channel: "JobEventsChannel", uuid: job.uuid },
        {
          received: (data: any) => {
            if (data.changed) {
              onJobChange();
            }
          },
        },
      );
      subscriptions.push(subscription);
    });

    return () => {
      subscriptions.forEach((subscription) => subscription.unsubscribe());
    };
  }, [limitingJobs, onJobChange, skipStates]);
}
